import axiosInstance from '../config/axios';
import { api } from '../config/api';
import { standardizeError } from '../utils/errorHandler';

const getTrafficStatus = async (data) => {
  try {
    const { zoomLevel, center, time } = data;
    const res = await axiosInstance.get(
      `${api.getTrafficStatus}?lat=${center[0]}&lng=${center[1]}&zoom=${
        zoomLevel + 3
      }&time=${time}&limit=10000`
    );
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};
const getTrafficStatusV2 = async (data) => {
  try {
    const { NElat, NElng, WSlat, WSlng, zoom } = data;
    const res = await axiosInstance.get(
      `${api.getTrafficStatusV2}?NElat=${NElat}&NElng=${NElng}&WSlat=${WSlat}&WSlng=${WSlng}&zoom=${zoom}`
    );
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const getTrafficStatusRectangle = async (data) => {
  try {
    const { NElat, NElng, WSlat, WSlng } = data;
    const res = await axiosInstance.get(
      `${api.getTrafficStatusV2}?NElat=${NElat}&NElng=${NElng}&WSlat=${WSlat}&WSlng=${WSlng}&level=4`
    );
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const getTrafficStatusCircle = async (data) => {
  try {
    const { center, radius_in_meter } = data;
    const res = await axiosInstance.get(
      `${api.getTrafficStatus}?lat=${center[0]}&lng=${center[1]}&radius_in_meter=${radius_in_meter}&level=4`
    );
    return res.data;
  } catch (error) {
    throw standardizeError(error);
  }
};

const Api = {
  getTrafficStatus,
  getTrafficStatusV2,
  getTrafficStatusRectangle,
  getTrafficStatusCircle,
};

export default Api;
